import React from 'react';
import { DropdownWrapper } from '../QsrDept.styles';
import Input from '../../../components/Input/Input';
import { StyledButtons } from '../../RawProdGINs/RawProdGins.style';
import Button from '../../../components/Button/Button';
import { AddQsrMasterModalProps } from './QsrModal.types';
import Modal from '../../../components/Modal/Modal';
import { Variant } from '../../../components/Button/Button.types';
import { StyledMessage } from '../../MandatoryInventory/MandatoryInventory.styles';
import Dropdown from '../../../components/Dropdown/Dropdown';

export const AddQsrDeptMasterModal = ({ open, onClose, onCancel, onConfirm, qsrDeptMasterDescription, handleQsrDeptMasterDescription, formErrors, classOptions, handleQsrDeptMasterClassNo }: AddQsrMasterModalProps): JSX.Element => {
  return (
    <Modal
      id="addQsrDeptMasterModal"
      open={open}
      onClose={onClose}
      title="Add QSR Department Master"
    >
      <div>
        <StyledMessage>
          Please enter a description for the new QSR Department Master.
        </StyledMessage>
        <Input
          label="Description"
          value={qsrDeptMasterDescription}
          onChange={handleQsrDeptMasterDescription}
          errorText={formErrors?.departmentDescription}
          id="addNewQsrMaster"
          testId={'AddNewMasterDescriptionInput'}
        />
        <DropdownWrapper>
          <Dropdown
            label="Class"
            id="classNo"
            dataTestId={'AddDeptClassDropdown'}
            options={[{ value: undefined, label: '' }, ...classOptions]}
            hidePlaceholder={true}
            onChange={handleQsrDeptMasterClassNo}
            errorText={formErrors?.classDescription}
          />
        </DropdownWrapper>
        <StyledButtons>
          <Button variant={Variant.Secondary} label="Cancel" onClick={onCancel}
                  testId={'AddNewMasterCloseButton'} />
          <Button label="Ok" onClick={onConfirm} testId={'AddNewMasterConfirmButton'} />
        </StyledButtons>
      </div>
    </Modal>
  );
};

export default AddQsrDeptMasterModal;
